import React from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import './PushTransition.css'

const timeout = { enter: 400, exit: 400 }

const PushTransition = ({ children, ...props }) =>
  <CSSTransition classNames="push-left" timeout={timeout} {...props}>
    <section className="absolute w-100 h-100">
      {children}
    </section>
  </CSSTransition>

PushTransition.propTypes = {
  children: PropTypes.object.isRequired
}

export default PushTransition



// WEBPACK FOOTER //
// ./src/components/PushTransition/PushTransition.js